import { FC, useState, useRef, useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { ICataloguesProductPositionCellProps } from './types';
import styles from './catalogueProductsTable.module.scss';

export const CataloguesProductPositionCell: FC<ICataloguesProductPositionCellProps> = ({ name, id, inputName }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const [isInput, setIsInput] = useState(false);

  const { control, getValues, setValue, watch } = useFormContext();

  const onBlur = () => {
    const val = getValues(inputName);
    if (isNaN(+val) || +val > 100 || +val < 0) {
      return;
    }
    // if (val > 100 || val < 0) return;
    const prods = [...getValues('products')];
    if (prods) {
      const index = prods.findIndex((item) => item.id === id);
      if (index !== -1) {
        prods[index].position[inputName] = +val;
        setValue('products', prods);
      }
    }
    setIsInput(false);
    setValue('selectedProdId', '');
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.setSelectionRange(0, 0);
      inputRef.current.scrollTo({ left: 0 });
    }
  }, [inputRef.current, isInput]);

  return (
    <div
      className={styles.posCell}
      onMouseDown={() => setValue('selectedProdId', id)}
      onMouseUp={() => {
        setValue(inputName, getValues(name));
        setIsInput(true);
      }}>
      {isInput ? (
        <Controller
          name={inputName}
          control={control}
          rules={{ required: true, max: 100, min: 0 }}
          render={({ field: { value, onChange } }) => (
            <input
              ref={inputRef}
              id={inputName + id}
              max={100}
              min={0}
              autoFocus
              type='text'
              value={value}
              style={{ width: '100%' }}
              className={styles.input}
              onBlur={onBlur}
              onChange={(e) => {
                onChange(e.currentTarget.value);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  (e.target as HTMLElement).blur();
                }
              }}
            />
          )}
        />
      ) : (
        <div>{watch(name) && watch(name).toFixed(2)}</div>
      )}
      %
    </div>
  );
};
